import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const CamsLogo = (props: any) => {
	return (
		<Svg
			width={49}
			height={13}
			viewBox='0 0 49 13'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<Path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M.06 5.528c.03-.23.068-.465.114-.706.235-1.156.78-2.249 1.592-3.193C2.593.65 3.91.105 5.719 0c.33.004.659.033.983.088a5.77 5.77 0 011.14.314c.6.247 1.17.644 1.71 1.192.54.547.938 1.326 1.193 2.335h-1.76c-.253-.862-.681-1.502-1.286-1.92-.605-.42-1.253-.629-1.945-.629h-.13a.371.371 0 00-.111.017c-.91.064-1.748.48-2.513 1.25-.766.768-1.172 1.871-1.219 3.308 0 1.727.386 2.974 1.158 3.742.772.768 1.618 1.157 2.538 1.167h.053c.898 0 1.728-.298 2.488-.893.76-.596 1.175-1.388 1.244-2.375h1.758c-.023.14-.049.281-.078.426a4.235 4.235 0 01-.112.441c-.317.984-.914 1.885-1.737 2.623-.857.795-1.937 1.192-3.24 1.192-1.97.054-3.438-.534-4.405-1.764C.48 9.284-.002 7.85 0 6.212c.011-.226.032-.453.06-.684z'
				fill='#0B509D'
			/>
			<Path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M17.406 2.153l-3.68 9.758h-1.903L16.316.125h2.04l4.613 11.785h-1.9l-3.663-9.758z'
				fill='#80807C'
			/>
			<Path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M24.62.126h2.525l3.671 9.885 3.67-9.885h2.543V11.91h-1.845V2.525l-3.527 9.386h-1.683l-3.526-9.258v9.258H24.62V.126zM40.563 8.115c0 .955.342 1.66 1.028 2.117a4.322 4.322 0 002.271.733h.14a4.352 4.352 0 002.028-.476c.29-.138.539-.333.724-.57.185-.237.302-.508.34-.79a.512.512 0 00.017-.12v-.12c0-.752-.337-1.26-1.01-1.523-.741-.28-1.514-.494-2.306-.636-.103-.021-.206-.04-.294-.056-.089-.017-.186-.035-.277-.056-.987-.192-1.93-.52-2.794-.973-.834-.44-1.2-1.31-1.097-2.61.068-.823.478-1.537 1.227-2.14.75-.604 1.838-.903 3.263-.895 1.428 0 2.57.306 3.429.917.858.612 1.254 1.485 1.188 2.62h-1.624v-.176c0-.666-.302-1.175-.906-1.529a4.14 4.14 0 00-1.996-.564h-.103a3.865 3.865 0 00-1.926.49c-.582.328-.89.84-.925 1.537.03.263.142.515.326.727.184.212.432.376.717.477.677.252 1.38.449 2.1.588l.432.098.45.096c.915.197 1.791.509 2.6.925.801.412 1.271 1.134 1.409 2.166.068 1.276-.427 2.246-1.486 2.911-1.02.654-2.254 1.014-3.526 1.031h-.05c-1.262.002-2.488-.359-3.483-1.024-1.053-.681-1.563-1.74-1.529-3.175h1.643zM22.863 3.67a.397.397 0 00-.259-.02l-1.733.181a.242.242 0 00-.137.125.195.195 0 00.006.172c.03.053.082.096.146.119a.324.324 0 00.201.004l.814-.068-1.12 1.091-2.072.116-.08.112-.719 1.066h-2.375l-.079.088-.72.84h-2.4l-.077.1-.88 1.2a.206.206 0 00-.04.08.191.191 0 000 .087c.007.029.02.056.04.08a.245.245 0 00.071.062.3.3 0 00.197.033.27.27 0 00.166-.095l.803-1.1h2.388l.078-.088.72-.838h2.416l.075-.113.72-1.067 2.013-.139.063-.054 1.298-1.206-.026.908a.195.195 0 00.011.087c.01.028.027.054.05.076.022.023.049.041.08.055a.294.294 0 00.288-.029.234.234 0 00.064-.068.2.2 0 00.028-.084l.091-1.51a.197.197 0 00-.023-.114.236.236 0 00-.087-.088z'
				fill='#0B509D'
			/>
		</Svg>
	);
}

export default CamsLogo;
